
// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import SideNav, {NavItem, NavIcon, NavText} from '@trendmicro/react-sidenav'
import history from '../../history'

import {withRouter} from 'react-router'

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

import '@trendmicro/react-sidenav/dist/react-sidenav.css'
import './index.css'

export function navItem (key, icon, text, className = null) {
  return (
    <NavItem
      eventKey={key}
      className={className || ''}
    >
      <NavIcon>
        {icon}
      </NavIcon>
      <NavText>
        {text}
      </NavText>
    </NavItem>
  )
}

class SideNavBar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      expanded: false
    }
  }

  render () {
    return (
      <div className='sidenav'>
        <SideNav
          onSelect={(selected) => {
            const to = `/${selected}/`
            if (this.props.location.pathname !== to) {
              history.push(to)
            }
          }}
          expanded={this.state.expanded}
          onToggle={(expanded) => {
            this.setState({expanded})
          }}
          className='sidenav'
        >
          <SideNav.Nav selected={this.props.selected}>
            {this.props.children}
          </SideNav.Nav>
          <div className={`toggle-button-container ${this.state.expanded ? 'expanded' : ''}`}>
            <i
              className='toggle-button'
              onClick={() => this.setState({expanded: !this.state.expanded})}
            >
              {this.state.expanded ? <ArrowBackIosIcon/> : <ArrowForwardIosIcon/>}
            </i>
          </div>
        </SideNav>
      </div>
    )
  }
}

export default withRouter(SideNavBar)
